// @flow
import type { HomepageOrder } from "./types";

export type SetHomepageOrder = {
  type: "SET_HOMEPAGE_ORDER_ACTION",
  payload: HomepageOrder
};

const setHomepageOrder = (value: HomepageOrder): SetHomepageOrder => ({
  type: "SET_HOMEPAGE_ORDER_ACTION",
  payload: value
});

export default setHomepageOrder;
